import { Copy } from '../copy/Copy';
import { Awesome } from '../icons/Awesome/Awesome';
import { Good } from '../icons/Good/Good';
import { Okay } from '../icons/Okay/Okay';
import { Sad } from '../icons/Sad/Sad';
import { Terrible } from '../icons/Terrible/Terrible';

export const MOOD_CHECK_RADIOS = [
  {
    value: '1',
    icon: Terrible,
    label: Copy.generate('Global.terrible'),
  },
  {
    value: '2',
    icon: Sad,
    label: Copy.generate('Global.sad'),
  },
  {
    value: '3',
    icon: Okay,
    label: Copy.generate('Global.okay'),
  },
  {
    value: '4',
    icon: Good,
    label: Copy.generate('Global.good'),
  },
  {
    value: '5',
    icon: Awesome,
    label: Copy.generate('Global.awesome'),
  },
];
